import { DesignFolder } from "../../../core/models/entities/DesignFolder";
import { DesignFolderDto } from "../responses/DesignFolderDto";

export function mapToDesignFolder(dto: DesignFolderDto): DesignFolder {
  return {
    id: dto.id,
    name: dto.name,
    parentId: dto.parentId ?? null,
    designCount: dto.designCount,
    // ?? 0 tolerates a backend that does not send logoCount yet.
    logoCount: dto.logoCount ?? 0,
    // Same tolerance for sortOrder (older backend = everything at 0, so the
    // pre-reorder rendering order is kept).
    sortOrder: dto.sortOrder ?? 0,
  };
}
